import t from"react";import o from"../../utils/classnames.js";import s from"../ButtonTooltip/ButtonTooltip.js";const a=({className:a,...e})=>t.createElement(s,{className:o("perxis-auto-car-tile-button-tooltip",a),...e});export{a as default};
//# sourceMappingURL=CarTileButtonTooltip.js.map
